import React from 'react';

const FormModal = ({ isOpen, onClose, formData }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-8 rounded-lg shadow-xl max-w-lg w-full relative max-h-[80vh] overflow-y-auto">
        <button onClick={onClose} className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 text-2xl font-bold">&times;</button>
        <h2 className="text-2xl font-bold mb-4">Form Details</h2>
        <div className="space-y-4">
          {Object.entries(formData).map(([key, value]) => (
            <div key={key}>
              <h3 className="font-semibold text-gray-700 capitalize">{key}</h3>
              <p className="text-gray-900">{value}</p>
            </div>
          ))}
        </div>
        
      </div>
    </div>
  );
};

export default FormModal;
